import { useProgramTypeApi } from "../api/ProgramTypeApiClient";
import { ProgramTypeFrontendService } from "../services/ProgramTypeFrontendService";

export const useProgramTypeService = (): ProgramTypeFrontendService =>
  new ProgramTypeFrontendService(useProgramTypeApi());
